import { SxProps, Theme } from '@mui/material/styles';

export const groupBaseSx: SxProps<Theme> = {};
